import { HeaderAreaProps } from '../types';

const HeaderArea = ({ header, subhead, categoryName }: HeaderAreaProps) => {
  return (
    <div className="flex flex-col gap-12 text-left sm:text-center">
      <h2 className="w-full text-3xl">{header}</h2>
      {!!subhead && <p className="mt-14">{subhead}</p>}
      {!!categoryName && <p className="mt-18 text-xl">{categoryName}</p>}
    </div>
  );
};

export default HeaderArea;
